module.exports = __webpack_public_path__ + "img/zev-education.b36dadb1.webp";